export default {
  components: {
  },
  props: ['item', 'index', 'transferType', 'projectSubType', 'needtoShow'],
  data() {
    return {
    };
  },
  created() {
  },
  computed: {
  },
  methods: {
  }
};
